"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setCustomError = _interopRequireDefault(require("./setCustomError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compareForValidity = function compareForValidity(elementA, elementB) {
  var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Your values do not match.";
  var isValid = elementA && elementA instanceof HTMLElement && elementB && elementB instanceof HTMLElement && elementA.value === elementB.value;
  !isValid && (0, _setCustomError.default)(elementA, errorMessage);
  return isValid;
};

var _default = compareForValidity;
exports.default = _default;